import { render, staticRenderFns } from "./regFormTrainee.vue?vue&type=template&id=046b1d69&scoped=true"
import script from "./regFormTrainee.vue?vue&type=script&lang=js"
export * from "./regFormTrainee.vue?vue&type=script&lang=js"
import style0 from "./regFormTrainee.vue?vue&type=style&index=0&id=046b1d69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b1d69",
  null
  
)

export default component.exports